import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import signActions from 'actions/signActions';
import { ProfileStep4 } from 'components/newAccountSteps/profileSteps/profileStep4/profileStep4';
import { actions as formActions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import UtagHelper from 'utilities/utagHelper';
import { getFinalizedContract, recordedFinalizedContract, recordPage, RELIABLE } from 'utilities/uTagging';
import { PATH_CONTRACT, PATH_CONTRACT_FINISHED } from 'constants/uTagConstants/paths';
import preLoaderActions from 'actions/preLoaderActions';
import Headline from 'components/headline';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { GBI, GBI_REJECTED, ROBO, ROBO_REJECTED } from 'constants/userProfile';
import DOCUMENTATION_PRODUCT_NAME from 'utilities/uTagging';
import cryptoJS from 'crypto-js';
import { SuccessSigningView } from 'routes/formsView/SuccessSigningView';
import { getViewNameByStatus } from 'actions/getViewNameByStatus';
import { LOGALTY_IMPLEMENTATION } from 'constants/steps';
import { SIGNED } from 'constants/statusProcess';
import ModalLoader from 'components/modalLoader/ModalLoader';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { BASE_PATH } from 'constants';
import { history } from 'routes/history';

class SigningContractView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalLoaderOpen: false,
        };

        this.onHandleChangeStep = this.onHandleChangeStep.bind(this);
        this.onHandleShowPreloader = this.onHandleShowPreloader.bind(this);
        this.onHandleHidePreloader = this.onHandleHidePreloader.bind(this);
        this.handleOpenStateError = this.handleOpenStateError.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { userProfile, sign } = this.props;

        if (userProfile.contract !== 'completed' || sign.get('status') !== 'completed') {
            this.onHandleShowPreloader();
        } else {
            this.onHandleHidePreloader();
        }
    }

    componentDidMount() {
        const { userProfile, products, immStepsState, signActions } = this.props;
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';

        if (userProfile.eventParam !== 'signing_complete') {
            signActions.getOnboardingImplementation(userProfile.accessToken, () => {
                history.push(`${BASE_PATH}/errors`);
            });
        }

        if (
            userProfile.contract === 'completed' ||
            (typeof userProfile.eventParam !== 'undefined' &&
                (userProfile.eventParam === 'signing_complete' || userProfile.eventParam === 'viewing_complete'))
        ) {
            if (!getFinalizedContract()) {
                recordedFinalizedContract();
                !immStepsState.get('welcomeCard') &&
                    recordPage(
                        PATH_CONTRACT_FINISHED,
                        userProfile.recordId,
                        userProfile.userId,
                        userProfile.product,
                        products.get('productsDescription'),
                        userProfile.promoCode ? userProfile.promoCode : '',
                        JointHolderInfo,
                        RELIABLE[userProfile.identityMethod],
                        '',
                        userProfile.investmentType,
                        {
                            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
                            identificadorOnboarding: docNumberEncrypted,
                            event_name: 'step_contract_signed',
                            pageName: '/onboarding/step7a/contractSigned',
                            sectionFamily: 'banking',
                            sectionCategory: 'onboarding',
                            sectionName: 'userOnboarding',
                            interactionType: 'funnel',
                            serviceType: 'onboarding',
                            processType: 'onboarding',
                            processStep: 'step7a',
                            processDetail: 'contractSigned',
                            onboardingType: userProfile.investmentType,
                            onboardingR: userProfile.clientRisk || '',
                            onboardingIdMethod: RELIABLE[userProfile.identityMethod],
                            onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
                        }
                    );
            }
        } else {
            !immStepsState.get('welcomeCard') &&
                recordPage(
                    PATH_CONTRACT,
                    userProfile.recordId,
                    userProfile.userId,
                    userProfile.product,
                    products.get('productsDescription'),
                    userProfile.promoCode ? userProfile.promoCode : '',
                    JointHolderInfo,
                    RELIABLE[userProfile.identityMethod],
                    '',
                    userProfile.investmentType,
                    {
                        identificadorOnboarding: docNumberEncrypted,
                        nombreProducto: DOCUMENTATION_PRODUCT_NAME,
                        event_name: 'step_contract',
                        pageName: '/onboarding/step7/contract',
                        sectionFamily: 'banking',
                        sectionCategory: 'onboarding',
                        sectionName: 'userOnboarding',
                        interactionType: 'funnel',
                        serviceType: 'onboarding',
                        processType: 'onboarding',
                        processStep: 'step7',
                        processDetail: 'contract',
                        onboardingType: userProfile.investmentType,
                        onboardingR: userProfile.clientRisk || '',
                        onboardingIdMethod: RELIABLE[userProfile.identityMethod],
                        onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
                    }
                );
        }
    }

    componentDidUpdate() {
        const { userProfile, sign } = this.props;

        if (userProfile.contract !== 'completed' || sign.get('status') !== 'completed') {
            this.onHandleHidePreloader();
        }

        return true;
    }

    onHandleShowPreloader() {
        const { userProfile, signActions, preLoaderActions, sign } = this.props;

        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        const contractToken = sign.get('contractToken');

        if (typeof userProfile.eventParam !== 'undefined' && userProfile.eventParam === 'signing_complete') {
            signActions.getContractStatus(userProfile.accessToken, isLogalty, contractToken);
            let checkStatusInterval;
            let openStateTimeout;
            let errorTimeout;
            const envelopeId = sign.get('envelopeId');

            if (typeof this.checkStatusInterval === 'undefined') {
                checkStatusInterval = setInterval(() => {
                    signActions.getContractStatus(userProfile.accessToken, isLogalty, contractToken);
                }, 3000);
                this.checkStatusInterval = checkStatusInterval;

                if (isLogalty) {
                    openStateTimeout = setTimeout(() => {
                        signActions.getOpenStateStatus(
                            userProfile.accessToken,
                            sign.get('contractToken'),
                            envelopeId,
                            this.handleOpenStateError
                        );
                    }, 30000);
                    this.openStateTimeout = openStateTimeout;

                    errorTimeout = setTimeout(() => {
                        clearInterval(this.checkStatusInterval);
                        history.push(`${BASE_PATH}/errors`);
                    }, 80000);
                    this.errorTimeout = errorTimeout;
                }
            }
            setTimeout(() => {
                if (isLogalty) {
                    this.setState({ modalLoaderOpen: true });
                } else {
                    preLoaderActions.setInformationText(formatText('informationText-signing'));
                    preLoaderActions.showPreLoader();
                }
            }, 250);
        }
    }

    handleOpenStateError() {
        clearInterval(this.checkStatusInterval);
        history.push(`${BASE_PATH}/errors`);
    }

    onHandleHidePreloader() {
        const { userProfile, preLoaderActions, sign } = this.props;
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        if (userProfile.contract === 'completed' || sign.get('status') === 'completed') {
            clearInterval(this.checkStatusInterval);
            if (isLogalty) {
                clearTimeout(this.forceRefreshTimeout);
                clearTimeout(this.errorTimeout);
                clearTimeout(this.openStateTimeout);
            }

            setTimeout(() => {
                if (isLogalty) {
                    this.setState({ modalLoaderOpen: false });
                } else {
                    preLoaderActions.hidePreLoader();
                }
            }, 250);
        }
    }

    onHandleChangeStep() {
        const { userProfile, signActions, formActions, actions, immStepsState, preLoaderActions } = this.props;
        const currentStep = immStepsState.get('currentStep');

        preLoaderActions.showPreLoader();
        signActions.confirmContract(userProfile.documentation, userProfile.accessToken, ({ status }) => {
            if (
                userProfile.investmentType === ROBO ||
                userProfile.investmentType === GBI ||
                userProfile.investmentType === ROBO_REJECTED ||
                userProfile.investmentType === GBI_REJECTED
            ) {
                formActions.change('userProfile.status', 'pre-documentation');
            } else {
                formActions.change('userProfile.status', status || 'documentation');
            }
            actions.finalizeStep({ index: currentStep, finished: true });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                viewName: getViewNameByStatus(status),
            });
            preLoaderActions.hidePreLoader();
        });
    }

    getSigningView() {
        return <ProfileStep4 />;
    }

    render() {
        const { userProfile, sign } = this.props;
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        const isOnboardingStatusSigned = userProfile.status === SIGNED;
        const isContractCompleted = userProfile.contract === 'completed';
        const isSigningComplete = userProfile.eventParam === 'signing_complete';
        const isViewingComplete = userProfile.eventParam === 'viewing_complete';

        if (
            (isOnboardingStatusSigned || isLogalty) &&
            (isContractCompleted || isSigningComplete || isViewingComplete)
        ) {
            return (
                <div className="basic-layering">
                    <ModalLoader open={this.state.modalLoaderOpen} onClose={null} />
                    <SuccessSigningView
                        investmentType={userProfile.investmentType}
                        onHandleChangeStep={this.onHandleChangeStep}
                    />
                    <WelcomeCard />
                </div>
            );
        }

        return (
            <div className="basic-layering">
                <div className="signing__header">
                    <Headline icon="firma" className="prospects-gutter">
                        <h2>{formatText('contentStepsTitles-signContract')}</h2>
                        <p>{formatText('contentStepsTitles-yourSignature')}</p>
                    </Headline>
                </div>
                {this.getSigningView()}
                <WelcomeCard />
            </div>
        );
    }
}

module.exports.constructor = SigningContractView;
module.exports.SigningContractView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        sign: state.sign,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        actions: bindActionCreators(stepsActions, dispatch),
        signActions: bindActionCreators(signActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(SigningContractView);
